// extracted by mini-css-extract-plugin
export default {"container":"InputBox_container__2j+6X","containerFull":"InputBox_containerFull__iuIkN","input":"InputBox_input__z77Ii","alert":"InputBox_alert__fXcEd"};